module.exports = __webpack_public_path__ + "img/DotkitPoster.3ca6bd3b.jpg";